var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Vue100vh',{staticClass:"welcome-layout"},[_vm._t("default"),(_vm.showLogo)?_c('img',{staticClass:"welcome-layout__logo",attrs:{"src":require("@/assets/images/logo.svg"),"alt":"ReSkript"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }